import { get, assign } from 'lodash';

import { capitalize } from 'utils';
import { PATH, PAGES } from 'constants/url';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  props: {
    meta: {
      required: false,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaEmptyResult,
  },
  data() {
    return {
      PATH,
      PAGES,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const title = get(vm, 'meta.title') || '';
      const section = get(vm, 'meta.section') || '';

      const titleTrans = vm.$t(title);
      const sectionTrans = vm.$t(section);

      const page = sectionTrans ? `${titleTrans} :: ${sectionTrans} :: ` : (titleTrans ? `${titleTrans} :: ` : '');

      const toPagePath = get(to, 'path', '');
      const label = toPagePath.startsWith(PATH.PROFESSIONAL) ? 'label.page_title_professionals' : 'label.page_title_participants';

      const pageTrans = vm.$t(label, { page });
      // console.log('beforeRouteEnter', to, title, section, page, pageTrans);

      document.title = pageTrans;
    });
  },
  methods: {
    onBackEvent() {
      const back = get(this.meta, 'navigation.back', false);
      if (back) this.$router.replace({ name: back });
    },
    onDoneEvent() {
      const back = get(this.meta, 'navigation.cancel', false);
      if (back) this.$router.replace({ name: back });
    },
    onCancelEvent() {
      const cancel = get(this.meta, 'navigation.cancel', false);
      if (cancel) this.$router.replace({ name: cancel });
    },
    onSuccessEvent(params, query) {
      const success = get(this.meta, 'navigation.success', false);
      const cancel = get(this.meta, 'navigation.cancel', false);
      const where = success || (cancel || false);
      const prmt = assign({}, { name: where }, { params }, { query });
      if (where) this.$router.replace(prmt);
    },
    successNotification(params) {
      const title = get(params, 'title', 'message.default_success_title');
      const message = get(params, 'message', 'message.default_success_message');
      const label = get(params, 'label', false);
      const value = label ? this.$t(label) : '';

      this.$notify({
        title: this.$t(title),
        message: capitalize(this.$t(message, { value })),
        type: 'success',
      });
    },
    errorNotification(params) {
      const title = get(params, 'title', 'message.default_error_title');
      const message = get(params, 'message', 'message.default_error_message');
      const label = get(params, 'label', false);
      const value = label ? this.$t(label) : '';

      this.$notify({
        title: this.$t(title),
        message: capitalize(this.$t(message, { value })),
        type: 'error',
      });
    },
    getMetaAttr(attr) {
      return get(this.meta, attr, '');
    },
    gotoPage(name) {
      this.$router.push({ name });
    },
  },
};




// WEBPACK FOOTER //
// ./src/components/mixins/page-props.js